import React from 'react';
import { useRef } from 'react';
import { useClickAway } from 'ahooks';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Footer from '@src/components/footer';
import Store from './store';

const styles = require('./index.less');

export default wrapStore(({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  const footerRef = useRef(null);

  useClickAway(() => {
    store.onClickClose();
  }, footerRef);

  return (
    <div className={cx(styles.footerModalRoot)}>
      <div ref={footerRef} className={cx(styles.footerRoot, { [styles.showFooter]: store.isOpen })}>
        <Footer onBackTop={store.onClickBackTop} />
      </div>
    </div>
  );
}, Store);
